import React from 'react'
import PropTypes from 'prop-types'

function DatePickerTableHeaderCell({text}) {
  return <div className="date-picker-kw-cell noselect">{text}</div>
}

DatePickerTableHeaderCell.propTypes = {
  text: PropTypes.string,
}

export default DatePickerTableHeaderCell
